export interface IListDataResponse {
  lists: IList[];
  status: string;
}

export interface IList {
  id: string;
  collection_id: string;
  parent_id: string | null;
  name: string;
  deleted: boolean;
  item_ids: string[];
}

export interface IListCreateRequest {
  name: string;
  collection_id: string;
  parent_id?: string;
}

export interface IAddToListRequest {
  list_id: string;
  collection_id: string;
  ids: string[];
}

export class ListNode {
  list: IList;
  children: ListNode[];
  parent?: ListNode;

  constructor(
    list: IList,
    children: ListNode[] = [],
    parent?: ListNode
  ) {
    this.list = list;
    this.children = children;
    this.parent = parent;
  }
}

export interface ListCreationPayload {
  collectionId: string;
  parentListId?: string;
}